import React from "react";
import { Link } from "react-router-dom";
import SectionTitle from "../../components/SectionTitle";
import { FREE_RESOURCES } from "../upsc-resources/upsc-resources-constants";
import SingleService from "../upsc-resources/SingleService";

const FreeResourcesSection = () => {
  return (
    <div className="campus_sec pt---40">
      <div className="container">
        <SectionTitle Title="Free Resources" />
        <div className="row">
          <div className="col-lg-12">
            <div className="react_popular_topics">
              <div className="container">
                <div className="row">
                  {FREE_RESOURCES.map((freeresource) => (
                    <div
                      key={freeresource.id} // Always add a unique key when mapping
                      className="col-lg-3 wow animate__fadeInUp"
                      data-wow-duration="0.3s"
                    >
                      <SingleService
                        itemImg={freeresource.resourceImg}
                        title={freeresource.title}
                        resourceId={freeresource.id}
                      />
                    </div>
                  )).slice(0, 4)}
                </div>
              </div>
            </div>
          </div>
          {/* <div className="col-lg-5">
            <div className="about__image">
              <img src={campusImg4} alt="image" />
              <img className="shape-1" src={campusShape} alt="image" />
            </div>
          </div> */}
        </div>
        <div className="text-center">
          <Link to="/upsc-resources" className="more-about">
            {" "}
            More about Free Resources{" "}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              className="feather feather-arrow-right"
            >
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FreeResourcesSection;
